import { useEffect, useState } from "react";

/**
 * Copies `value` to the clipboard. Falls back to a select-all hint when the
 * clipboard API is unavailable (http origins, older browsers), because the
 * refusal screen is useless if the DID cannot leave the page.
 */
export function CopyButton({
  value,
  label = "Copy",
  className = "small",
}: {
  value: string;
  label?: string;
  className?: string;
}) {
  const [state, setState] = useState<"idle" | "copied" | "failed">("idle");

  useEffect(() => {
    if (state === "idle") return;
    const timer = setTimeout(() => setState("idle"), 2000);
    return () => clearTimeout(timer);
  }, [state]);

  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        navigator.clipboard
          ?.writeText(value)
          .then(() => setState("copied"))
          .catch(() => setState("failed"));
      }}
    >
      {state === "copied" ? "Copied" : state === "failed" ? "Select and copy" : label}
    </button>
  );
}
